import { Container, ContainerModule, Newable } from 'inversify';
import { IAppConfigBase } from './IAppConfigBase';
import { TYPES } from '../types';

export interface ConfigFactory<TConfig> {
  create(): TConfig,
}

type InferConfig<F> = F extends ConfigFactory<infer R> ? R : never;

export const createConfigModule = <
  TFactory extends ConfigFactory<InferConfig<TFactory>>,
>(
  factoryClass: Newable<TFactory>,
  appConfig: symbol = TYPES.AppConfig,
): ContainerModule => {
  return new ContainerModule(({ bind }) => {
    bind<TFactory>(factoryClass).toSelf().inSingletonScope();

    bind<InferConfig<TFactory>>(appConfig)
      .toDynamicValue(({ get }) => {
        return get<TFactory>(factoryClass).create();
      })
      .inSingletonScope();
  });
};

export const getAppConfig = <T extends IAppConfigBase = IAppConfigBase>(
  container: Container,
  appConfig: symbol = TYPES.AppConfig,
): T => {
  return container.get<T>(appConfig);
};
